var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2531_480)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6312 14.12C12.3864 14.4148 12.0911 14.6512 11.7631 14.8151C11.435 14.9791 11.0809 15.0673 10.7218 15.0744C10.3627 15.0815 10.0061 15.0074 9.67306 14.8565C9.34006 14.7056 9.03756 14.4811 8.78361 14.1962C8.52967 13.9113 8.32947 13.572 8.19497 13.1984C8.06046 12.8249 7.99441 12.4247 8.00074 12.0219C8.00708 11.6191 8.08568 11.2219 8.23184 10.8539C8.37801 10.4859 8.58875 10.1547 8.8515 9.88003M16.0365 17.94C14.5126 19.243 12.6571 19.9649 10.7413 20C4.50129 20 0.935547 12 0.935547 12C2.0444 9.68192 3.58234 7.65663 5.44621 6.06003L16.0365 17.94ZM8.86933 4.24002C9.48293 4.0789 10.1112 3.99836 10.7413 4.00003C16.9814 4.00003 20.5471 12 20.5471 12C20.006 13.1356 19.3607 14.2048 18.6216 15.19L8.86933 4.24002Z",
    stroke: "#414141",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.935547 1L20.5471 23",
    stroke: "#414141",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2531_480"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.3945,
    height: 24,
    fill: "white",
    transform: "translate(0.0449219)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye-off.245fd67a2369fb7190acab661ba35dd8.svg";
export { ForwardRef as ReactComponent };